module.exports = __webpack_public_path__ + "static/img/wait.ad236fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wait.png
// module id = pNDR
// module chunks = 1